import { Component } from '@angular/core';

@Component({
  selector: 'mtm-redo-icon',
  templateUrl: './redo-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class RedoIconComponent {}
